import React from 'react';
import { Stack } from 'rsuite';
import ProductHoldButton from './hold/ProductHoldButton';

interface Props {
  offerId: number;
  stockQuantity: number;
  isOnHold: boolean;
  holdReason?: string;
  marketplace: string;
}

export default function ProductTableStockQuantity({
  offerId, stockQuantity, isOnHold, holdReason, marketplace,
}: Props): JSX.Element {
  const inStockQuantity = stockQuantity > 99 ? '99+' : stockQuantity;

  return (
    <Stack
      spacing={5}
      justifyContent="center"
      alignItems="center"
    >
      <span title={stockQuantity.toString()}>{inStockQuantity}</span>
      <ProductHoldButton
        offerId={offerId}
        isOnHold={isOnHold}
        holdReason={holdReason}
        marketplace={marketplace}
      />
    </Stack>
  );
}

ProductTableStockQuantity.defaultProps = {
  holdReason: undefined,
};
